import { InputNumber, Space } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import SearchParam from '../SearchParam';
import FilterButton from './FilterButton';

interface FilterRangeProps {
  nameMin: string;
  nameMax: string;
}

const FilterSalaryRange = ({ nameMin, nameMax }: FilterRangeProps) => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  return (
    <Space direction="vertical">
      <Space direction="horizontal">
        <SearchParam name={nameMin} onSetSearchParams={{ page: '1' }}>
          <InputNumber
            data-testid="start-filter-salary-range-input"
            addonBefore={t('R$')}
            min={0}
            max={2147483647}
          />
        </SearchParam>
        <Trans>até</Trans>
        <SearchParam name={nameMax} onSetSearchParams={{ page: '1' }}>
          <InputNumber
            data-testid="end-filter-salary-range-input"
            addonBefore={t('R$')}
            min={0}
            max={2147483647}
          />
        </SearchParam>
      </Space>
      <SearchParam
        array
        name={nameMin}
        onSetSearchParams={{ page: '1', [nameMax]: '' }}
        valuePropName="disabledValue"
      >
        <FilterButton disabled={!(searchParams.get(nameMin) || searchParams.get(nameMax))}>
          <Trans>Limpar</Trans>
        </FilterButton>
      </SearchParam>
    </Space>
  );
};

export default FilterSalaryRange;
